module.exports = __webpack_public_path__ + "fonts/iconfont.5d320a57.woff2";